import { render, staticRenderFns } from "./Freeca.vue?vue&type=template&id=12518a78&scoped=true"
import script from "./Freeca.vue?vue&type=script&lang=js"
export * from "./Freeca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12518a78",
  null
  
)

export default component.exports